// Fade in layer before anything else
fadeInPage();

// highlight main header menu active link
const mainHeaderMenu = document.querySelector(".main-header-menu");
if (mainHeaderMenu) {
  const currentLink = mainHeaderMenu.querySelector(
    `a[href$="${window.location.pathname}"]`
  );
  if (currentLink) {
    currentLink.classList.add('active')
  }
}

// highlight account header active link
const accountPageMenu = document.querySelector(".account-page__menu");
if (accountPageMenu) {
  const currentLink = accountPageMenu.querySelector(
    `a[href$="${window.location.pathname}"]`
  );
  if (currentLink) {
    currentLink.classList.add('active')
  }
}

// Helper function used in other js files (i.e. horizontal-scroll.js), so using 'function' so we can declare it multiple times with the same exact name
function getRandomSize(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}
//Start and load cart for more info see https://github.com/bornfight/goCart.js
window.addEventListener("load", function () {
  // Add white background to header on hover
  const header = document.querySelector(".site-header");
  const headerMenuTriggers = document.querySelectorAll(".main-header-menu__trigger");
  headerMenuTriggers.forEach(trigger => trigger.addEventListener("mouseenter", () => header.classList.add("active")))
  headerMenuTriggers.forEach(trigger => trigger.addEventListener("mouseleave", () => header.classList.remove("active")))

  // hide menu on scroll
  const toggleMenu = () => {
    const mainMenu = document.querySelector(".main-header-menu-wrapper");
    const boostCollectionFilters = document.querySelector('.collection__filters');
    var currentScrollPos = window.pageYOffset;
    const scrollThreshold = window.innerWidth < 1024 ? 36 : 60;
    const searchPageHader = document.querySelector(".search-page__header");
    const searchScrollThreshold = window.innerWidth < 1024 ? 116 : 80;

    if (mainMenu) {
      if (currentScrollPos > scrollThreshold) {
        mainMenu.classList.add("main-header-menu__up");
      } else {
        mainMenu.classList.remove("main-header-menu__up");
      }
    }

    if (boostCollectionFilters && window.screen.width >= 1024) {
      if (currentScrollPos > 200) {
        boostCollectionFilters.style.opacity = '0';
        boostCollectionFilters.style.pointerEvents = 'none';
      } else {
        boostCollectionFilters.style.opacity = '1';
        boostCollectionFilters.style.pointerEvents = 'auto';
      }
    }

    if (searchPageHader) {
      if (currentScrollPos > searchScrollThreshold) {
        searchPageHader?.classList.add("search-page__header--invisible");
      } else {
        searchPageHader.classList.remove("search-page__header--invisible");
      }
    }
  };

  toggleMenu();
  window.addEventListener("scroll", toggleMenu, {passive: true});

  // Newsletter form conditional button visibility
  const newsletterInputs = document.querySelectorAll(".newsletter__input");
  const emailRegex = /\S+@\S+\.\S+/;

  const showSubmitBtn = (newsletterInput) => {
    const submitBtn = newsletterInput.parentNode.querySelector(
      ".newsletter-submit-btn"
    );
    if (emailRegex.test(String(newsletterInput.value).toLowerCase())) {
      submitBtn.style.opacity = "1";
      submitBtn.style.pointerEvents = "all";
    } else {
      submitBtn.style.opacity = "0";
      submitBtn.style.pointerEvents = "none";
    }
  };

  newsletterInputs.forEach((newsletterInput) => {
    newsletterInput.addEventListener("keyup", () => {
      showSubmitBtn(newsletterInput);
    });
  });

  // hamburger & dropdown menu
  const menuButton = document.querySelector("[data-hamburger-button]");
  const menuOverlay = document.querySelector("[data-hamburger-overlay]");
  const menuDrawer = document.querySelector("[data-hamburger-wrapper]");
  const menuContainer = document.querySelector(
    "[data-hamburger-list-container]"
  );
  const dropdownItems = document.querySelectorAll("[data-drop-down]");
  const allLinks = menuContainer && menuContainer.querySelectorAll("a");
  const storeSwitchers = document.querySelectorAll('[data-store-switcher]');

  storeSwitchers.forEach(storeSwitcher => {
    storeSwitcher.addEventListener('click', (event) => {
      event.stopPropagation();
      event.currentTarget.classList.toggle('store-switcher--open');
      document.body.classList.toggle('no-scroll');
    });
  })

  const handleMenuEscKey = (e) => e.key === "Escape" && closeMenu();

  const openMenu = () => {
    document.body.classList.add('no-scroll','hamburger-active'); // Disable scrolling to body
    menuDrawer.classList.add("hamburger-menu__wrapper--open");
    menuOverlay.classList.add("hamburger-menu__overlay--active");
    document.addEventListener("keyup", handleMenuEscKey);
  };

  const closeMenu = (e) => {
    // e === undefined when closeMenu triggered by "esc" keyup event
    // (!menuDrawer.contains(e.target) && !menuContainer.contains(e.target)) triggered when from clicking the overlay
    if (
      e === undefined ||
      (!menuDrawer.contains(e.target) && !menuContainer.contains(e.target))
    ) {
      document.body.classList.remove('no-scroll','hamburger-active'); // Re-enable scrolling to body
      menuDrawer.classList.remove("hamburger-menu__wrapper--open");
      menuOverlay.classList.remove("hamburger-menu__overlay--active");
      document.removeEventListener("keyup", handleMenuEscKey);
    }
  };

  function closeMenuBeforeNavigation() {
    menuDrawer.classList.remove("hamburger-menu__wrapper--open");
    menuOverlay.classList.remove("hamburger-menu__overlay--active");
  }

  function toggleDropdown(e) {
    const childList = e.target.nextElementSibling;
    const arrow = e.target.lastElementChild;
    childList.classList.toggle("hamburger-menu__list-children--open");
    arrow.classList.toggle("hamburger-menu__arrow--open");
  }

  menuButton && menuButton.addEventListener("click", openMenu);
  menuOverlay && menuOverlay.addEventListener("click", closeMenu);

  if (allLinks) {
    for (const link of allLinks) {
      link.addEventListener("click", closeMenuBeforeNavigation);
    }
  }

  if (dropdownItems) {
    for (const item of dropdownItems) {
      item.addEventListener("click", toggleDropdown);
    }
  }

  // //search drawer
  // const openSearchButton = document.querySelector(
  //   "[data-predictive-search-open-drawer]"
  // );
  // const searchBar = document.querySelector("[data-predictive-search-drawer]");
  // const searchOverlay = document.querySelector("[data-predictive-overlay]");
  // const mainMenu = document.querySelector(".main-header-menu-wrapper");
  // const hamburger = document.querySelector("[data-hamburger-button]");
  // const breadcrumbs = document.querySelector(".breadcrumbs");
  // const closeHamburger = document.querySelector(
  //   "[data-search-close-button]"
  // );
  // const searchInput = document.querySelector(".algolia-shopify-autocomplete");
  // const autoComplete = document.querySelector(".algolia-autocomplete");
  // const bigButton = document.querySelector("[data-search-big-button]");
  // const searchForm = document.querySelector(".search-page-form");
  // // Stop submit on search form as that redirects to /search page
  // searchForm.addEventListener("submit", (e) => {
  //   e.preventDefault();
  // });

  // let keyCounter = 0;

  // const handleSearchEscKey = e => {
  //   // note: Algolia already comes with an esc keyup listener to clear the search text

  //   // First time pressing esc key and searchInput is empty --> close search
  //   if (keyCounter === 0 && e.key === "Escape" && searchInput.value === "") {
  //     handleSearchClose();
  //   }
  //   keyCounter += 1;

  //   // Algolia has successfully cleared text or search input is empty --> next esc key needs to close search 
  //   if (searchInput.value === "") {
  //     document.addEventListener("keyup", handleSecondEscKey);
  //   } else {
  //     document.removeEventListener("keyup", handleSecondEscKey);
  //   }
  // };

  // const handleSecondEscKey = (e) => {
  //   e.key === "Escape" && handleSearchClose();
  // };

  // const handleSearchOpen = () => {
  //   autoComplete.classList.remove("visually-hidden");
  //   breadcrumbs && breadcrumbs.classList.add("visually-hidden");
  //   searchBar.classList.add("search-bar--open");
  //   document.body.classList.add("no-scroll");
  //   closeHamburger.classList.remove("visually-hidden");
  //   hamburger.classList.add("visually-hidden");
  //   mainMenu && mainMenu.classList.add("visually-hidden");
  //   searchInput.focus();
  //   document.addEventListener("keyup", handleSearchEscKey);
  // };

  // const handleSearchClose = () => {
  //   autoComplete.classList.add("visually-hidden");
  //   breadcrumbs && breadcrumbs.classList.remove("visually-hidden");
  //   searchBar.classList.remove("search-bar--open");
  //   document.body.classList.remove("no-scroll");
  //   closeHamburger.classList.add("visually-hidden");
  //   hamburger.classList.remove("visually-hidden");
  //   mainMenu && mainMenu.classList.remove("visually-hidden");
  //   document.removeEventListener("keyup", handleSearchEscKey);
  // };

  // openSearchButton.addEventListener("click", handleSearchOpen);
  // searchOverlay.addEventListener("click", handleSearchClose);
  // closeHamburger && closeHamburger.addEventListener("click", handleSearchClose);
  // bigButton && bigButton.addEventListener("click", handleSearchOpen);

  // Login form for raffle page

  const raffleLogInForm = document.querySelector('#shopify-section-article-raffle-template #customer_login');
  const recoverPasswordForm = document.querySelector('#raffle__RecoverPasswordForm');
  const forgotPasswordButton = document.querySelector('#raffle__RecoverPassword');
  const cancelPasswordResetButtons = document.querySelectorAll('#shopify-section-article-raffle-template .HideRecoverPasswordLink');
  
  const showResetPasswordForm = () => {
    raffleLogInForm.classList.add('hide');
    recoverPasswordForm.classList.remove('hide');
  }

  const hideResetPasswordForm = () => {
    raffleLogInForm.classList.remove('hide');
    recoverPasswordForm.classList.add('hide');
  }
  
  forgotPasswordButton && forgotPasswordButton.addEventListener('click', e => {
    e.preventDefault();
    showResetPasswordForm();
  })

  cancelPasswordResetButtons.forEach(button => 
    button.addEventListener('click', e => {
      e.preventDefault();
      raffleLogInForm.classList.remove('hide');
      hideResetPasswordForm();
    })
  )

  const raffleResetPasswordSuccess = document.querySelector('.reset-password-success');
  const showResetPasswordSuccess = () => {
    showResetPasswordForm();
    raffleResetPasswordSuccess.classList.remove('hide');
  }
  raffleResetPasswordSuccess && showResetPasswordSuccess();
});

// blog clipboard button
const blogClipboardButton = document.querySelector(".blog-others__sharing-link--copy")
if (blogClipboardButton) {
  const clipboardText = blogClipboardButton.dataset.articleUrl
  const blogClipboardButtonText = blogClipboardButton.querySelector("p")
  blogClipboardButton.addEventListener('click', () => {
    navigator.clipboard.writeText(clipboardText).then(function () {
      /* clipboard successfully set */
      blogClipboardButtonText.innerText = "Copied!"
      blogClipboardButtonText.style.fontWeight = "bold"
      setTimeout(() => {
        blogClipboardButtonText.innerText = "Copy"
        blogClipboardButtonText.style.fontWeight = "normal"
      }, 2500)
    }, function () {
      /* clipboard write failed */
      console.log("Failed to copy to clipboard")
    });
  })
}


// blog filter button
const blogFilterCloseButton = document.querySelector(".blog-filter__close");
const blogFilterButton = document.querySelector(".blog-filter__button");
const blogFilterOptions = document.querySelector(".blog-filter__list-wrapper");
const blogFilterArrow = document.querySelector(".blog-filter__expand");

blogFilterButton && blogFilterButton.addEventListener(
  "click",
  () => {
    blogFilterOptions.classList.toggle("blog-filter__option-list--open");
    blogFilterOptions.classList.toggle("blog-filter__list-wrapper--open");
    blogFilterArrow.classList.toggle("blog-filter__expand--open");
    // block body scroll only on mobile as on desktop we do not use a full page menu with a button to toggle the body scroll back
    window.screen.width < 1024 && document.body.classList.add("no-scroll");
  },
  false
);

blogFilterCloseButton && blogFilterCloseButton.addEventListener(
  "click",
  () => {
    blogFilterOptions.classList.toggle("blog-filter__option-list--open");
    blogFilterOptions.classList.toggle("blog-filter__list-wrapper--open");
    blogFilterArrow.classList.toggle("blog-filter__expand--open");
    // block body scroll only on mobile as on desktop we do not use a full page menu with a button to toggle the body scroll back
    window.screen.width < 1024 && document.body.classList.remove("no-scroll");
  },
  false
);

// generate irregular grid home page
const homePageProducts = document.querySelectorAll(
  ".infinite-scroll__item.product"
);
const homePageBlogs = document.querySelectorAll(".infinite-scroll__item.blog");
const overviewBlogs = document.querySelectorAll(
  ".infinite-scroll__item.blog-small"
);

if (window.screen.width >= 750) {
  for (const [i, homePageProduct] of homePageProducts.entries()) {
    let isFifthIteration = (i + 1) % 5 === 0;

    if (isFifthIteration) {
      homePageProduct.classList.add("s2");
    } else {
      homePageProduct.classList.add("s1");
    }

    if (homePageProduct.classList.contains("s2")) {
      homePageProduct.querySelector("h3").classList.add("h3");
      homePageProduct.padding = `${getRandomSize(8, 16)}px`;
    } else {
      homePageProduct.querySelector("h3").classList.add("h3-patta-custom");
    }
  }

  for (const homePageBlog of homePageBlogs) {
    homePageBlog.classList.add(`s${getRandomSize(1, 2)}`);
    if (homePageBlog.classList.contains("s1")) {
      homePageBlog.querySelector("h3").classList.add("h3-patta-custom");
    } else {
      homePageBlog.querySelector("h3").classList.add("h3");
    }
  }

  for (const overviewBlog of overviewBlogs) {
    overviewBlog.classList.add(`s${getRandomSize(1, 2)}`);
    overviewBlog.padding = `${getRandomSize(4, 8)}px`;
    if (overviewBlog.classList.contains("s1")) {
      overviewBlog.querySelector("h3").classList.add("h3-patta-custom");
    } else {
      overviewBlog.querySelector("h3").classList.add("h3");
    }
  }
}

function fadeInPage() {
  if (!window.AnimationEvent) {
    return;
  }
  const layer = document.getElementById("transitionLayer");
  layer.classList.add("fade-out");
}

// document.addEventListener("DOMContentLoaded", () => {
//   // Return if browser doesn't support animation events
//   if (!window.AnimationEvent) {
//     return;
//   }

//   // Only do page transition for desktop (transitions seemed too slow on mobile)
//   if (window.screen.width >= 1024) {
//     const anchors = document.querySelectorAll("a");

//     anchors.forEach(anchor => {
//       // If anchor link is linking to a section to the same page but different ID section OR anchor link is linking to a page outside of Patta
//       if (
//         anchor.hostname !== window.location.hostname ||
//         anchor.pathname === window.location.pathname
//       ) {
//         anchor.addEventListener("click", (event) => {
//           setTimeout(() => {
//             const layer = document.getElementById("transitionLayer");
//             const anchor = event.currentTarget;
//             window.location = anchor.href;
  
//             event.preventDefault();
//             layer.classList.add("fade-in");
//           }, 500)
//         });
//       }
//     })
//   }
// });

window.addEventListener("pageshow", function (event) {
  if (!event.persisted) {
    return;
  }
  const layer = document.getElementById("transitionLayer");
  layer.classList.remove("fade-in");
});


// Hide filter buttons on footer
// const filterButton = document.querySelector(".boost-pfs-filter-button");
// const page = document.querySelector("#MainContent");

// const hideCollectionButton = () => {
//   window.screen.width < 1024 && hideButton(filterButton);
// }

// const hideBlogButton = () => {
//   window.screen.width < 1024 && hideButton(filterButton);
// }

// const hideButton = (button) => {
//   console.log('hiding button');
//   console.log(button);
//   const footer = document.querySelector('footer');
//   const pageHeight = page.scrollHeight;
//   const offset = window.pageYOffset;
//   const footerOffset = pageHeight - footer.getBoundingClientRect().height;

//   offset > footerOffset ? button.style.display = "none" : button.style.display = "block";
// }

// filterButton && document.addEventListener("scroll", hideCollectionButton);
// blogFilterButton && document.addEventListener("scroll", hideBlogButton);


// Helper function to remove UFOC (unstyled flash of content)
const domReady = (callback) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? callback()
    : document.addEventListener('DOMContentLoaded', callback);
};

domReady(() => {
  // Display body when DOM is loaded
  document.body.style.visibility = 'visible';
})

const languageElem = document.querySelectorAll('[data-languages]')

const getLang = iso => {
  return window.Phill.languages[iso]
}

const getPathName = (current, target) => {
  let targetPath = target !== '/' ? target : ''
  let currentPath = current !== '/' ? current : ''
  return window.location.pathname.replace(currentPath, targetPath)
}

const getPreferredLang = () => {
  const browserLang = navigator.languages.find(l => getLang(l)) || 'en'
  const lang = localStorage.getItem('pref_lang') || browserLang
  return {
    root: getLang(lang),
    lang: lang
  }
}

const changeLanguage = (current, target) => {
  localStorage.setItem('pref_lang', target)
  window.location.pathname = getPathName(current, getLang(target))
}

const languageSelector = node => {
  const list = node.querySelector('[data-list]')
  const items = node.querySelectorAll('[data-item]')
  const select = node.querySelector('[data-select]')
  const preferred = getPreferredLang()

  let value = select.value
  let currentLanguage = getLang(value)

  if(preferred.root !== currentLanguage) changeLanguage(currentLanguage, preferred.lang)

  node.addEventListener('click', () => {
    list.classList.toggle('open')
  })

  items.forEach(item => {
    item.addEventListener('click', () => {
      value = item.dataset.value
      select.value = value
      changeLanguage(currentLanguage, value)
    })
  })
}

languageElem.forEach(languageSelector)

const syncHeight = () => {
  document.documentElement.style.setProperty(
    "--window-inner-height",
    `${window.innerHeight}px`
  );
}

window.addEventListener("resize", syncHeight);

let scrollY; // we'll store the scroll position here

function preventDefault(e) {
  e.preventDefault();
}

function lockBody(modal, lockDelay) {
  if (window.innerWidth < 1024) {
    // remember scroll position
    scrollY = window.scrollY;
    if (modal) {
      modal.addEventListener("pointermove", preventDefault);
    }
    if (lockDelay) {
      // no-scroll-mobile will scroll page to top, so we delay it if the modal doesn't cover the full screen right away (i.e. cart drawer slide in animation)
      setTimeout(() => {
        document.documentElement.classList.add("no-scroll-mobile");
      }, 500)
    } else {
      document.documentElement.classList.add("no-scroll-mobile");
    }
  } else {
    document.body.classList.add("no-scroll");
  }
}

function unlockBody(modal) {
  if (window.innerWidth < 1024) {
    document.documentElement.classList.remove("no-scroll-mobile");
    if (modal) {  
      modal.removeEventListener("pointermove", preventDefault);
    }
    // restore scroll position
    window.scrollTo(0, scrollY);
  } else {
    document.body.classList.remove("no-scroll");
  }
}